import { createBrowserHistory, createMemoryHistory } from 'history';

import { getCurrentPathname } from './LocationHelper';
import { isTestEnv, isStorybookEnv } from '../devOpsHelper/DevOps';

let history;
let configuration;

export function getHistory() {
    return history;
}

export function setHistoryConfiguration(configurationPreDefined) {
    configuration = configurationPreDefined;
}

export function setURLPath(relativePath) {
    setHistoryConfiguration({ initialEntries: [relativePath] });
}

export function configureHistory() {
    if (isTestEnv() || isStorybookEnv()) {
        history = createMemoryHistory({
            initialEntries: ['/'],
            initialIndex: 0,
            ...configuration
        });
    } else {
        //TODO: check as this allows the first folder word in the pathname to be the root of the pandora application
        const basename = getCurrentPathname().match(/^(\/?[\w]*)/i)[0];
        history = createBrowserHistory({
            basename: basename
        });
    }

    return history;
}

export function getCurrentLocation() {
    return history && history.location;
}

export function updateURLTo(requestedLocation, options = {}) {
    const newLocation = {
        pathname: requestedLocation.pathname,
        search: requestedLocation.search,
        hash: history.location.hash,
        state: {
            stopEventPropagation: true,
            keepScrollPosition: false,
            ...options
        }
    };
    history.replace(newLocation);
}

export function navigateTo(requestedLocation) {
    const newLocation = {
        pathname: requestedLocation.pathname,
        search: requestedLocation.search,
        hash: requestedLocation.hash,
        state: {}
    };

    if (history.location.pathname === requestedLocation.pathname) {
        history.replace(newLocation);
    } else {
        history.push(newLocation);
    }
}

function isNotCurrentPathname(pathname) {
    return (
        history && history.location && history.location.pathname !== pathname
    );
}

function isNotCurrentSearch(search) {
    return history && history.location && history.location.search !== search;
}

export function isNotCurrentRelativeURL(pathname, search) {
    return isNotCurrentPathname(pathname) || isNotCurrentSearch(search);
}
